import { DEPOSIT_STATES } from '@deposits-system/contracts';
import { z } from 'zod';

/**
 * The deposits list keeps its filters in the URL, so returning from a
 * deposit's details restores the same list. Default state: في حوزتنا
 * (cash-deposits.md section 8.1, LIST-01).
 */
export const depositsSearchSchema = z.object({
  page: z.coerce.number().int().positive().optional().catch(undefined),
  pageSize: z.coerce.number().int().positive().max(100).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  from: z.iso.date().optional().catch(undefined),
  to: z.iso.date().optional().catch(undefined),
  dateType: z.enum(['DEPOSIT', 'DELIVERY']).optional().catch(undefined),
  state: z
    .enum([...DEPOSIT_STATES, 'ALL'])
    .optional()
    .catch(undefined),
  branchId: z.string().optional().catch(undefined),
  currencyId: z.string().optional().catch(undefined),
  depositEmployeeId: z.string().optional().catch(undefined),
  deliveryEmployeeId: z.string().optional().catch(undefined),
  returnEmployeeId: z.string().optional().catch(undefined),
  referralPending: z.boolean().optional().catch(undefined),
  sortBy: z.enum(['number', 'depositedAt', 'closedAt', 'amount']).optional().catch(undefined),
  sortDir: z.enum(['asc', 'desc']).optional().catch(undefined),
});
export type DepositsSearch = z.infer<typeof depositsSearchSchema>;

export const DEFAULT_PAGE_SIZE = 20;

/** Filters other than the default state and paging; used for the reset action. */
export function activeFilterCount(search: DepositsSearch): number {
  const keys: (keyof DepositsSearch)[] = [
    'from',
    'to',
    'branchId',
    'currencyId',
    'depositEmployeeId',
    'deliveryEmployeeId',
    'returnEmployeeId',
    'referralPending',
  ];
  let count = keys.filter((key) => search[key] !== undefined && search[key] !== false).length;
  if (search.state && search.state !== 'IN_CUSTODY') count += 1;
  if (search.dateType && search.dateType !== 'DEPOSIT') count += 1;
  return count;
}
